<template>
  <div class="s-information-detail-container">
    <topNav></topNav>
    <div class="s-information-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="s-information-detail w1300">
      <div class="s-information-detail-down">
        <div class="s-information-detail-title">
          {{ infoDetail.informationTitle }}
        </div>
        <div class="s-information-detail-sub">
          <div class="s-information-date">
            时间：{{ infoDetail.uploadDate }}
          </div>
          <div v-if="infoDetail.dataSources" class="s-information-source">
            来源：{{ infoDetail.dataSources }}
          </div>
        </div>
      </div>
      <div class="s-information-detail-img marginAuto">
      </div>
      <div class="s-information-detail-info" v-html="infoDetail.informationDetailStr">
      </div>
    </div>
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import { getInformationDetails } from '../utils/api/agriculture'
export default {
  name: "informationDetail",
  components: { topNav, footerNav },
  data() {
    return {
      id: "",
      infoDetail: {},
      imgUrlBank: "",
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getInformationDetails();
  },
  methods: {
    async getInformationDetails() {
      let params = {
        informationId: this.id,
      };
      let res = await getInformationDetails(params);
      if (res.data.code === 0) {
        this.infoDetail = res.data.data;
      }
    },
  },
};
</script>
<style lang="scss">
@import "../utils/css/common.scss";
@import "../utils/css/informationDetail.scss";
</style>
<style lang="scss" scoped></style>